import React from 'react';
import './box.scss';

const Box = ({ child }) => {
    return(
        <div className="f-box">
           {child}
        </div>
    )
}

export default Box;